export const queryKeys = {
  PROFILE_VIEW: "profile-view",
}